import { Fragment } from "react";

import { MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
import { Loader } from "../../../UI/Loaders/Loaders";
import useAllRoles from "../../../custom-hooks/useAllRoles";
import { useDispatch } from "react-redux";
import { showModal } from "../../../redux/actions/modal";
import CustomBadge from "../../Badge/badge";
import useAllPermissions from "../../../custom-hooks/useAllPermissions";

type TTableRow = {
  code: string;
  name: string;
  id: number;
};

const ManageAdminRoles = () => {
  const { data, error, status } = useAllRoles();
  const { data: allPermissions } = useAllPermissions();

  const dispatch = useDispatch();

  const modalHandler = (modalData: TTableRow, action: string) => {
    if (action === "manage") {
      dispatch(
        showModal({
          modalIdentifier: "createuser",
          dataRecord: {
            ...modalData,
            type: "update_role_permissions",
            allPermissions,
          },
        })
      );
    }
  };

  //JSX Template
  let RenderedComponent = null;
  if (!data && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Roles
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading") {
    RenderedComponent = <Loader centered="true" text="Loading roles..." />;
  } else {
    if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              roles, Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (data && data.length === 0) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no logged
              activities
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <div className="grid__padding animated fadeInRight">
          <MDBTable
            className="centralize-table-items"
            responsive
            minimal="true"
            bordered
            hover
          >
            <MDBTableHead>
              <tr>
                <th>S/N</th>
                <th>User Role</th>
                <th>Role Code</th>
                <th>Manage</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {data &&
                data.length &&
                data.map((role: TTableRow, idx: number) => {
                  const { code, name, id } = role;
                  return (
                    <tr key={id}>
                      <td>{idx + 1}</td>
                      <td>{name}</td>
                      <td>
                        <CustomBadge
                          text={code}
                          customStyle={{
                            display: "inline-block",
                            backgroundColor: "#F4F5F6",
                            borderRadius: "0.2rem",
                            color: "#000",
                          }}
                        />
                      </td>
                      <td className="space-items">
                        <div className="dropdown">
                          <button
                            className="btn zoom-element btn-slim dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          ></button>
                          <div
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            {/* <span
                              className="cursor-pointer dropdown-item"
                              onClick={() => {
                                modalHandler(role);
                              }}
                            >
                              VIEW
                            </span> */}
                            <span
                              className="cursor-pointer dropdown-item"
                              onClick={() => modalHandler(role, "manage")}
                            >
                              MANAGE PERMISSIONS
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </MDBTableBody>
          </MDBTable>
        </div>
      );
    }
  }

  return <Fragment>{RenderedComponent}</Fragment>;
};

export default ManageAdminRoles;
